import React, { useEffect, useState } from 'react';
import { CheckCircle2, ClipboardList } from 'lucide-react';
import toast from 'react-hot-toast';
import { holidayApi } from '../api/axios';

const HolidayApprovalPanel = ({ t }) => {
  const [year, setYear] = useState(new Date().getFullYear());
  const [proposals, setProposals] = useState([]);

  const load = async () => {
    try {
      const response = await holidayApi.listRecommendations(year);
      setProposals(response.data || []);
    } catch (error) {
      toast.error(error.response?.data?.detail || t('err_holiday_proposals', 'Tatil önerileri yüklenemedi.'));
    }
  };

  useEffect(() => { load(); }, [year]);

  const approve = async (proposalId) => {
    try {
      await holidayApi.approveRecommendation(proposalId);
      await load();
      toast.success(t('msg_holiday_proposal_approved', 'Tatil takvimi onaylandı.'));
    } catch (error) {
      toast.error(error.response?.data?.detail || t('err_holiday_proposal_approve', 'Tatil takvimi onaylanamadı.'));
    }
  };

  return (
    <div className="mt-5 rounded-2xl border border-indigo-100 bg-indigo-50 px-4 py-4">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-xs font-black uppercase tracking-[0.14em] text-indigo-800"><ClipboardList size={15} /> {t('holiday_approval_title', 'Takvim öneri onayı')}</div>
        <select value={year} onChange={(event) => setYear(Number(event.target.value))} className="rounded-lg border border-indigo-200 bg-white px-2 py-1 text-xs font-bold">
          {Array.from({ length: 17 }, (_, index) => new Date().getFullYear() - 1 + index).map((value) => <option key={value} value={value}>{value}</option>)}
        </select>
      </div>
      <div className="mt-3 space-y-2">
        {proposals.length ? proposals.map((proposal) => (
          <div key={proposal.id} className="flex items-center justify-between gap-3 rounded-xl bg-white px-3 py-2 text-xs">
            <span className="font-semibold text-slate-700">{proposal.jurisdiction_code} · {proposal.year} · {proposal.policy_version}</span>
            {proposal.status === 'APPROVED' ? <span className="flex items-center gap-1 font-bold text-emerald-700"><CheckCircle2 size={14} /> {proposal.status}</span> : <button type="button" onClick={() => approve(proposal.id)} className="rounded-lg bg-indigo-600 px-3 py-2 text-[10px] font-black uppercase text-white">{t('holiday_approve_button', 'Onayla')}</button>}
          </div>
        )) : <p className="text-xs text-indigo-700">{t('holiday_no_proposals', 'Bu yıl için bekleyen öneri yok.')}</p>}
      </div>
    </div>
  );
};

export default HolidayApprovalPanel;